<app-individual-plan class="subpage-content"></app-individual-plan>

<div #dialogFooter></div>
